import React from 'react';
import { Box } from '@chakra-ui/react';
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import MiniPlayer from "./MiniPlayer";
import { useAudioPlayer } from '../context/AudioPlayerContext';

const Layout = ({ children }) => {
  const { currentEpisode } = useAudioPlayer();

  return (
    <Box
      minH="100vh"
      display="flex"
      flexDirection="column"
      bg="#150d04"
      pb={currentEpisode ? { base: '84px', md: '64px' } : 0}
    >
      <ScrollToTop />
      <Navbar />
      <Box
        as="main"
        flex="1"
        width="100%"
      >
        {children}
      </Box>
      <Footer />
      <MiniPlayer />
    </Box>
  );
};

export default Layout;
